import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtm from '@gtm-support/vue2-gtm'
import Instances from './views/Instances'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(() => {})
}

const routes = [{
  path: '/',
  redirect: '/instances'
}, {
  path: '/applications',
  name: 'applications',
  meta: { gtm: 'Sites' },
  component: () => import(/* webpackChunkName: "applications" */ './views/Applications')
}, {
  path: '/incidents',
  name: 'incidents',
  meta: { gtm: 'Incidents' },
  component: () => import(/* webpackChunkName: "incidents" */ './views/Incidents')
}, {
  path: '/instances',
  name: 'instances',
  meta: { gtm: 'Instances' },
  component: Instances,
  children: [{
    path: ':id',
    name: 'layout',
    meta: { gtm: 'Instance' },
    component: () => import(/* webpackChunkName: "instance" */ './components/Instance/Layout'),
    children: [{
      path: 'increase',
      meta: { gtm: 'Increase Disk Size' },
      component: () => import(/* webpackChunkName: "instance-increase" */ './components/Instance/Increase')
    }, {
      path: 'resize',
      meta: { gtm: 'Change Server Type' },
      component: () => import(/* webpackChunkName: "instance-resize" */ './components/Instance/Resize')
    }, {
      path: 'transfer',
      meta: { gtm: 'Transfer' },
      component: () => import(/* webpackChunkName: "instance-transfer" */ './components/Instance/Transfer')
    }, {
      path: 'metrics',
      meta: { gtm: 'Metrics' },
      component: () => import(/* webpackChunkName: "instance-metrics" */ './components/Instance/Metrics')
    }, {
      path: 'bundle/:bundleId',
      meta: { gtm: 'Install bundle' },
      component: () => import(/* webpackChunkName: "instance-bundle" */ './components/Instance/Bundle')
    }, {
      path: ':applicationId/:menu?',
      name: 'application',
      meta: { gtm: 'Application' },
      component: () => import(/* webpackChunkName: "instance-application" */ './components/Instance/Application')
    }]
  }]
}, {
  path: '/create/:type?',
  name: 'create',
  meta: { gtm: 'Create' },
  component: () => import(/* webpackChunkName: "create" */ './views/Create')
}, {
  path: '/team',
  meta: { gtm: 'Team' },
  component: () => import(/* webpackChunkName: "team" */ './views/Team')
}, {
  path: '/billing',
  name: 'billing',
  meta: { gtm: 'Billing' },
  component: () => import(/* webpackChunkName: "billing" */ './views/Billing')
}, {
  path: '/account',
  name: 'account',
  meta: { gtm: 'Account' },
  component: () => import(/* webpackChunkName: "account" */ './views/Account')
}, {
  path: '/projects',
  name: 'projects',
  meta: { gtm: 'Projects' },
  component: () => import(/* webpackChunkName: "projects" */ './views/Projects')
}, {
  path: '/ssh-key',
  name: 'ssh-key',
  meta: { gtm: 'SSH Key' },
  component: () => import(/* webpackChunkName: "ssh-key" */ './views/SshKey')
}, {
  path: '/tokens',
  name: 'tokens',
  meta: { gtm: 'API Keys' },
  component: () => import(/* webpackChunkName: "tokens" */ './views/Tokens')
}]

const router = new VueRouter({ routes })

Vue.use(VueGtm, {
  id: 'GTM-MDQRLL6',
  defer: false,
  enabled: process.env.NODE_ENV === 'production',
  debug: process.env.NODE_ENV !== 'production',
  loadScript: true,
  vueRouter: router
})

export default router
